import { ReactNode } from "react";

type Props = {
  image: ReactNode;
  body: ReactNode | string;
  contactUs?: ReactNode | string;
  frameContent: ReactNode;
  overlayStyle: "consumer" | "ico";
};

const PurchaseFrameLayout = ({
  image,
  body,
  contactUs,
  frameContent,
  overlayStyle,
}: Props) => {
  return (
    <div className={`bg-gray-25 no-scrollbar ${overlayStyle}-overlay h-full`}>
      <div className="mx-auto flex justify-center align-middle flex-col gap-2 lg:gap-8 xl:flex-row pb-6 px-4 sm:px-14 lg:px-20 xl:px-10 pt-12 max-w-[118.75rem]">
        <div
          id="image-body-section"
          className="flex-col mt-4 w-full xl:mt-9 xl:max-w-[600px] mx-auto xl:mx-0"
        >
          <div className="flex w-full mx-auto mb-4">{image}</div>
          <div className="flex flex-col pb-4 px-6 text-left">
            {body}
            <span className="xl:inline-block hidden mt-8">{contactUs}</span>
          </div>
        </div>

        <div
          id="frame-section"
          className="flex flex-col items-center justify-center"
        >
          <div className="bg-white h-fit w-full xl:w-[568px] shadow-lg rounded-xl px-5 py-8 lg:px-8 lg:py-10">
            {frameContent}
          </div>
        </div>
        <span className="inline-block xl:hidden mt-8 text-left mx-4">
          {contactUs}
        </span>
      </div>
    </div>
  );
};

export default PurchaseFrameLayout;
